import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  StreamHeader,
  StreamHeaderProps,
} from '../../../features/StreamHeader/StreamHeader';
import {StreamHeaderErrorView} from '../../../features/StreamHeader/StreamHeaderErrorView';
import {StreamHeaderLoading} from '../../../features/StreamHeader/StreamHeaderLoading';
import {useBrandShopFilters} from '../utils/useBrandShopFilters';

export const BrandShopStreamHeader: React.FC<
  PriorityConfig & StreamHeaderProps
> = props => {
  return (
    <DataFetcher
      request={useBrandShopFilters()}
      Error={StreamHeaderErrorView}
      Loading={StreamHeaderLoading}
      View={StreamHeader}
      viewProps={props}
      renderingPriority={props.renderingPriority}
    />
  );
};
